<template>
  <div class="pt-panel trunk-info-panel">
    <div class="pt-header">
      <div class="pt-header-text">
        <div class="pt-kicker">工程信息</div>
        <h2 class="pt-title">{{ oneTitle }}</h2>
        <p class="pt-subtitle">支线工程参数 · 管线布置</p>
      </div>
      <button class="pt-close" @click="closeClick">&times;</button>
    </div>

    <div class="pt-flex-table">
      <div class="pt-flex-table-header">
        <div class="pt-flex-table-cell">名称</div>
        <div class="pt-flex-table-cell">长度</div>
      </div>
      <div
          class="pt-flex-table-row"
          v-for="(item, index) in lineData"
          :key="index"
      >
        <div class="pt-flex-table-cell">{{ item.name }}</div>
        <div class="pt-flex-table-cell">{{ item.length }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "branchTrunkInfo",
  data() {
    return {
      oneTitle: "支线详情",
      lineData: [
        { name: "新建压力管道", length: "320.14km" },
        { name: "改建渠道为压力管道", length: "131.53km" },
        { name: "利用输水渠道",  length: " 39.42km" },
      ],
    };
  },
  methods: {
    closeClick() {
      this.$emit("infoClose");
    },
  },
};
</script>

<style scoped>
.trunk-info-panel {
  width: 45%;
  height: 65%;
  position: absolute;
  overflow-y: auto;
  max-height: 65%;
  left: 30%;
  top: 200px;
}
</style>
